<template>
  <div class="question-item white rounded-5" :question_index="question_index">
    <!-- TOP BAR -->
    <div
      class="top-bar position-relative w-100 pointer d-flex justify-content-between align-items-start nowrap"
      @click="toggleBottomBar"
    >
      <div class="d-flex justify-content-start align-items-start">
        <div class="checkbox checkbox-md checkbox-inline ignore">
          <input
            type="checkbox"
            @click="check"
            class="ignore"
            :checked="selected"
          />
        </div>

        <!-- QUESTION INFO -->
        <div class="info">
          <div class="question color_text" v-html="question">
            {{ question }}
          </div>
          <div class="question-info">
            <span
              class="type font-weight-bold text-uppercase"
              :class="setTypeColor()"
              >{{ question_difficulty }}</span
            >
            <span v-if="question_difficulty">&nbsp; • &nbsp;</span>
            <span class="duration color_grey_dark"
              >Duration: {{ question_duration }}</span
            >
          </div>
        </div>
      </div>

      <div class="show-more">
        <div class="avatar">
          <div class="icon-caret-down font-10 color_ash flex-center"></div>
        </div>
      </div>
    </div>

    <!-- BOTTOM BAR -->
    <div class="bottom-bar" v-if="show_bottom_bar">
      <div class="wrapper w-100">
        <!-- OPTIONS BLOCK -->
        <div class="left">
          <div class="option-block">
            <div
              class="d-flex justify-content-start align-items-start flex-wrap"
              v-if="
                (question_data.type == 'multichoice' ||
                  question_data.type == 'multiple') &&
                  question_options !== null
              "
            >
              <OptionCard
                :option_id="option.id"
                :option_value="option.value"
                :option_correct="option.correct"
                :option_sm="true"
                :key="index"
                v-for="(option, index) in question_options"
              ></OptionCard>
              <OptionCard
                v-if="question_data.option_e"
                option_id="e"
                :option_sm="true"
                :option_value="question_data.option_e"
                :option_correct="
                  question_data.answer.toLowerCase() === 'e' ? true : false
                "
              ></OptionCard>
            </div>
            <div v-else-if="question_data.type == 'bool'">
              <OptionCard
                option_id="a"
                option_value="TRUE"
                :option_sm="true"
                :option_correct="Number(question_data.answer) ? true : false"
              ></OptionCard>
              <OptionCard
                option_id="b"
                option_value="FALSE"
                :option_sm="true"
                :option_correct="!Number(question_data.answer) ? true : false"
              ></OptionCard>
            </div>
            <!-- OPTIONS -->
          </div>
        </div>

        <!-- EXPLANATION BLOCK -->
        <div class="right">
          <!-- IMAGE BLOCK -->
          <div class="image-block" v-if="question_data.image">
            <img :src="question_data.image" alt="" />
          </div>

          <div class="explanation-block color_white_bg rounded-5" v-if="false">
            <div class="title color_grey_dark font-weight-600">EXPLANATION</div>

            <!-- EXPLANATION TEXT -->
            <div
              class="explanation-text color_text"
              v-if="question_data.explanation"
              v-html="question_data.explanation"
            ></div>
            <div class="explanation-text color_text" v-else>
              No explanation available
            </div>

            <!-- VIDEO EXPLANATION -->
            <div
              class="video-explanation rounded-5 brand_accent_light_bg pointer"
              :class="
                !question_data.video_explanation ? 'disabled-video' : null
              "
            >
              <div class="icon-play brand_accent font-25 mr-2"></div>
              <div
                class="text font-13 brand_primary"
                v-if="question_data.video_explanation"
              >
                Watch the video explanation
              </div>
              <div class="text font-13 brand_primary" v-else>
                No video explanation available
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="feedback-bottom d-flex justify-content-start align-items-center nowrap"
      >
        <div class="avatar mr-2">
          <span class="icon-flag border_grey_dark flex-center font-18"></span>
        </div>
        <div class="text color_ash">
          Have an issue with this question?
          <router-link
            to
            class="brand_accent"
            @click.native="$emit('toggleFeedback')"
            >Submit Feedback</router-link
          >
        </div>
      </div>
    </div>

    <script
      type="application/javascript"
      defer
      async="true"
      src="https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"
    ></script>
  </div>
</template>

<script>
import OptionCard from "@/components/classComps/assessment/OptionCard";

export default {
  name: "QuestionCard",

  components: {
    OptionCard,
  },

  props: {
    question: String,
    question_duration: String,
    question_difficulty: String,
    question_type: String,
    question_id: Number,
    question_index: Number,
    parent_index: Number,
    selected: Boolean,
    question_data: Object,
    question_options: Array,
  },

  data() {
    return {
      easy: "brand_navy",
      medium: "brand_accent",
      hard: "brand_tonic",
      question_type_color: null,
      show_bottom_bar: false,
    };
  },

  methods: {
    toggleBottomBar($event) {
      if (!$event.target.classList.contains("ignore")) {
        this.show_bottom_bar = !this.show_bottom_bar;
      }
    },

    check($event) {
      console.log(this.question_id);
      if ($event.target.checked)
        this.$emit("pickQuestion", {
          question_id: this.question_id,
        });
      else
        this.$emit("removeQuestion", {
          question_id: this.question_id,
        });
    },

    setTypeColor() {
      if (this.question_difficulty.toLowerCase() === "easy") return this.easy;
      else if (this.question_difficulty.toLowerCase() === "medium")
        return this.medium;
      else if (this.question_difficulty.toLowerCase() === "hard")
        return this.hard;
    },
  },
};
</script>

<style lang="scss">
.question-item {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  margin-bottom: 2px;
  padding: 12px 13px 10px 15px;

  @include breakpoint_max(xs) {
    padding: 10px;
    margin-bottom: 3px;
  }

  .top-bar {
    padding-right: 5px;
    padding-bottom: 12px;

    .checkbox {
      position: relative;
      top: -6px;
      margin-right: 13px;

      @include breakpoint_max(sm) {
        margin-right: 7px;
      }

      @include breakpoint_max(xs) {
        margin-right: 5px;
      }
    }

    .info {
      .question {
        font-size: 15px;
        line-height: 22px;
        margin-bottom: 2.5px;

        @include breakpoint_max(lg) {
          font-size: 13.5px;
        }

        @include breakpoint_max(sm) {
          font-size: 12.5px;
          line-height: 19px;
        }

        @include breakpoint_max(xs) {
          font-size: 12.25px;
        }
      }

      .question-info {
        font-size: 13px;
        line-height: 18px;

        @include breakpoint_max(lg) {
          font-size: 12.5px;
          line-height: 17px;
        }

        @include breakpoint_max(sm) {
          font-size: 12px;
        }

        @include breakpoint_max(xs) {
          font-size: 11.75px;
        }
      }
    }
  }

  .bottom-bar {
    padding: 13px 0 0;
    border-top: 1px solid #d5d5d5;

    .wrapper {
      @include flex_row_between_nowrap;
      align-items: flex-start;
      @include breakpoint_max(md) {
        @include flex_column_start;
      }
    }

    .left {
      width: 55%;
      @include breakpoint_max(md) {
        width: 100%;
      }
    }

    .right {
      width: 45%;
      @include breakpoint_max(md) {
        width: 100%;
      }
    }

    .image-block {
      margin-bottom: 10px;
      img {
        width: 85%;
        height: auto;
      }
    }

    .explanation-block {
      padding: 15px 20px;

      .title {
        font-size: 13.5px;
        line-height: 19px;
        margin-bottom: 10px;
      }

      .explanation-text {
        line-height: 165%;
        font-size: 13.5px;
        margin-bottom: 30px;
      }

      .video-explanation {
        padding: 8px 16px;
        @include flex_row_start_nowrap;
      }
    }

    .feedback-bottom {
      margin-top: 12px;
      border-top: 1px solid #d5d5d5;
      padding: 10px 0 0;
      font-size: 13.5px;
      line-height: 18px;

      @include breakpoint_max(sm) {
        font-size: 12.5px;
      }
    }
  }

  .disabled-video {
    cursor: not-allowed;
    background: $brand_inverse_light !important;

    .icon-play {
      color: $color_ash !important;
    }
  }
}
</style>
